<template>
    <div>
        <a
            v-if="isReviewHaveResponse"
            href="#"
            class="text-primary guest-response"
            @click.prevent="showGuestResponseModal"
        >
            {{ reviewResponse }}
        </a>
        <modal :id="guestResponseModalId" title="Guest Response" ok-only ok-title="Close">
            {{ reviewResponse }}
        </modal>
    </div>
</template>

<script>
import Modal from '../../../../generic/modal/modal.vue';

export default {
    components: { Modal },
    data() {
        return {
            guestResponseModalId: null,
            review: null,
        };
    },
    created() {
        this.guestResponseModalId = `guest-response-modal-id-${this.params.data.id}`;
        this.review = this.params.data;
    },
    computed: {
        isReviewHaveResponse() {
            return this.review.guest_review_response ? true : false;
        },
        reviewResponse() {
            return this.isReviewHaveResponse ? this.review.guest_review_response.response : '';
        },
    },
    methods: {
        showGuestResponseModal() {
            this.$bvModal.show(this.guestResponseModalId);
        },
    },
};
</script>

<style lang="scss" scoped>
.guest-response {
    display: block;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    text-decoration: underline;
}
</style>
